import { UI } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { HStack, VStack } from 'native-base';
import React from 'react';

import { TableContent } from '../../../../../../../../../components/TableContent';
import { LateralBar } from '../../../../../../../../BatchTicket/components/DynamicAsset/components/Asset/components/LateralBar';
import {
  DetailsSkeleton,
  DoubleTextSkeleton,
  TextSkeleton,
} from '../../../../../../../../BatchTicket/components/DynamicAsset/components/AssetsLoading';
import { useGlobalProductContext } from '../../../../../contexts';

export const ListLoadingItemTablet: React.FC = () => {
  const { product } = useGlobalProductContext();

  const middleInfos1 = [
    { label: 'Aplic. Min.', value: <DoubleTextSkeleton w="45%" /> },
    { label: 'Vencimento', value: <DoubleTextSkeleton w="50%" /> },
    { label: 'Carência', value: <DoubleTextSkeleton w="52%" /> },
  ];

  const middleInfos2 = [
    { label: 'Liquidez', value: <TextSkeleton w="60%" /> },
    { label: 'Taxa', value: <TextSkeleton w="35%" /> },
    { label: 'Rent. até venc.', value: <TextSkeleton w="40%" /> },
  ];

  return (
    <TableContent direction="row" space={0} p={0} px={Spacing['inline.xxxs']}>
      <LateralBar
        backgroundColor={product.color}
        borderTopLeftRadius={BoxRadius.sm}
        borderBottomLeftRadius={BoxRadius.sm}
      />
      <VStack padding={Spacing['inset.sm']} space={Spacing['stack.xxxs']} w="full">
        <HStack justifyContent="space-between" alignItems="center" w="full">
          <TextSkeleton w="60%" hasCaptions />
          <DetailsSkeleton />
        </HStack>
        <HStack justifyContent="space-between">
          {middleInfos1.map(({ label, value }) => (
            <VStack space={Spacing['stack.quarck']} key={label} w="1/3">
              <UI.Text color="neutral.black" variant="semibold">
                {label}
              </UI.Text>
              {value}
            </VStack>
          ))}
        </HStack>
        <HStack justifyContent="space-between">
          {middleInfos2.map(({ label, value }) => (
            <VStack space={Spacing['stack.quarck']} key={label} w="1/3">
              <UI.Text color="neutral.black" variant="semibold">
                {label}
              </UI.Text>
              {value}
            </VStack>
          ))}
        </HStack>
      </VStack>
    </TableContent>
  );
};
